// src/config.js
const API_BASE_URL = "https://scolivre.com/api";

export default API_BASE_URL;
